// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"MP-z","inlineTitle":"NP-z","sponsoredAdsWrapper":"OP-z","marketplaceRecosWrapper":"PP-z"};